import aiContentProjectAgent from 'common/src/modules/aiContent/copilot/agents/aiContentProjectAgent/aiContentProjectAgent';
import {FeatureFlagKey} from 'common/src/modules/featureFlags/featureFlags.types';
import isFlagEnabled from 'common/src/modules/featureFlags/utils/isFlagEnabled';
import {CLStore} from 'common/src/redux/store';
import {copilot} from '@cl/shared';

function initializeAiContentAgents(store: CLStore) {
  if (isFlagEnabled(FeatureFlagKey.EnableCopilotAiContentProjectAgent)) {
    copilot.registerAgent(aiContentProjectAgent(store));
  }
}

export default initializeAiContentAgents;
